module.exports = __webpack_public_path__ + "static/media/4.acc4c264.png";